<script setup lang="ts">
import AnalyticsCardShell from './AnalyticsCardShell.vue';
import { formatInt } from './analyticsUtils';

defineProps<{
    title: string;
    description: string;
    metaLabel: string;
    rows: { id: string; label: string; count: number; pct: number }[];
}>();
</script>

<template>
    <AnalyticsCardShell :title="title" :description="description">
        <template #meta>
            <span
                class="shrink-0 text-xs font-medium text-muted-foreground tabular-nums"
            >
                {{ metaLabel }}
            </span>
        </template>

        <p v-if="!rows.length" class="py-2.5 text-sm text-muted-foreground">
            No messages over this period.
        </p>

        <div v-else class="flex flex-col">
            <div
                v-for="row in rows"
                :key="row.id"
                class="grid min-w-0 grid-cols-[minmax(0,1fr)_4.25rem_3.5rem] items-baseline gap-x-2 border-b border-grey20 py-3 tabular-nums last:border-b-0 last:pb-0"
            >
                <span
                    class="min-w-0 break-words text-[13px] font-medium leading-relaxed text-foreground"
                >
                    {{ row.label }}
                </span>
                <span class="text-right text-base font-bold whitespace-nowrap">
                    {{ formatInt(row.count) }}
                </span>
                <span
                    class="text-right text-[13px] text-muted-foreground whitespace-nowrap"
                >
                    {{ row.pct }}%
                </span>
            </div>
        </div>
    </AnalyticsCardShell>
</template>
